import { Trans } from '@lingui/react/macro';
import { Breadcrumbs, Breadcrumb, Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { ScreenLayout } from 'shared/domains/common-ui/ScreenLayout';
import { useTasks } from '../TasksProvider';
export function TaskHeader() {
    const { setDisplayAdd } = useTasks();
    return (<ScreenLayout.Topbar breadcrumbs={<Breadcrumbs>
          <Breadcrumb as={Link} to="/dashboard">
            <Trans comment="Dashboard breadcrumb">Dashboard</Trans>
          </Breadcrumb>
          <Breadcrumb>
            <Trans comment="Tasks breadcrumb">Tasks</Trans>
          </Breadcrumb>
        </Breadcrumbs>} actions={<Button type="button" size="xs" appearance="secondary" onClick={() => setDisplayAdd(true)}>
          <Falcon icon="plus"/>
          <Trans comment="add new task button">Task</Trans>
        </Button>}/>);
}
